import React, { useState, useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import {
    Select as SENDER_SELECT,
    SelectBank as BANK_SELECT,
    ViewBeneficiary as BENE_SELECT,
    AddBeneficiary as BENE_ADD,
    MoneyTransfer as DMT_TRANSFER,
    GenerateOTPForSender as GENERATE_OTP_ForMoneyTransfer
} from 'Components/Api/NovityDMTAPI';

import ReactTable from 'Components/ReactTable/ReactTable';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Paper, Button, Hidden } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { KeyValueModal } from 'Components/Modal/KeyValueModal';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_PROVIDE_VALID,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';

import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';
import { useLocation } from 'react-router-dom';
import HOCLoader from 'Components/Loader/HOCLoader';
import { OTPModal } from 'Components/Modal/OTPModal';
import usePosition from 'Components/Posistion';
const CustomContainer = HOCLoader(Container);

export const BeneficiaryAdd = () => {
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [bankList, setBankList] = useState([]);
    const { latitude, longitude } = usePosition();
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [isOtpDialogOpen, setIsOtpDialogOpen] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [bankDefault, setBankDefault] = useState({
        Name: 'Select Bank',
        BankID: 0,
        DefaultIFSC: ''
    });
    const [isBeneVerifyOpen, setIsBeneVerifyOpen] = useState(false);
    const [modalErrorMessage, setModalErrorMessage] = useState('');
    const [openOTP, setOpenOTP] = useState(false);
    const [refID, setOTPRefID] = useState(false);
    const [VerifyOTPParams, setVerifyOTPParams] = useState();
    const [BeneVerifyDetails, setBeneVerifyDetails] = useState([]);

    const [verifyStatus, setVerifyStatus] = useState('');
    const [beneID, setBeneID] = useState('');
    const [isAddOnly, setIsAddOnly] = useState(false);
    const [isReadOnly, setReadOnly] = useState(false);
    const [mainColumns, setMainColumns] = useState([]);
    const [list, setList] = useState([]);
    const Mobile = location?.state?.Mobile;
    const BankPipe = location?.state?.BankPipe;
    const SenderID = location?.state?.SenderID;
    const SenderName = location?.state?.SenderName;
    const ActiveDMTName = location?.state?.DMTName;

    const [ShowConfirmAccountNumberInBeneAdd] = useState(
        localStorage.getItem('ShowConfirmAccountNumberInBeneAdd')
    );
    const [ShowBeneMobileNumberInBeneAdd] = useState(
        localStorage.getItem('ShowBeneMobileNumberInBeneAdd')
    );

    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        BankPipe: BankPipe,
        Name: '',
        SenderName: SenderName,
        Bank: bankDefault,
        AccountNo: '',
        ConfirmAccountNo: '',
        IFSC: '',
        SenderID: SenderID,
        isAddOnly: false,
        BeneMobile: '',
        ActiveDMTName: ActiveDMTName,
        Latitude: latitude,
        Longitude: longitude
    });

    useEffect(() => {
        selectBank();
        selectBene();
        createColumns();
    }, []);
    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'BeneficiaryID',
            srno: true
        });
        columns.push({
            label: 'Name',
            name: 'Name'
        });
        columns.push({
            label: 'Bank',
            name: 'BankName'
        });
        columns.push({
            label: 'AccountNo',
            name: 'AccountNo'
        });

        columns.push({
            label: 'IFSC',
            name: 'IFSC'
        });

        setMainColumns(columns);
    };

    const selectBene = async () => {
        setLoading(true);
        setIsError(false);

        if (Mobile === undefined) return;

        if (Mobile === '') return;

        var beneReqObj = JSON.stringify({
            Mobile: Mobile,
            DMTName: ActiveDMTName,
            BankPipe: BankPipe
        });
        var response = await BENE_SELECT(beneReqObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);
        setBeneID(data[0].BeneficiaryID);
        setList(data);
    };

    const select = async () => {
        setLoading(true);

        let primaryID = Mobile;

        setLoading(false);
        if (primaryID === 'DMT') {
            return;
        }

        var requestObj = JSON.stringify({
            Mobile: primaryID
        });
        var response = await SENDER_SELECT(requestObj);

        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);

        setFormObject({
            ...formObject,
            Mobile: data.Mobile,
            BankPipe: BankPipe,
            SenderID: data.SenderID
        });
    };

    const selectBank = async () => {
        setLoading(true);
        var ReqObj = JSON.stringify({
            DMTName: ActiveDMTName
        });

        const response = await BANK_SELECT(ReqObj);

        setLoading(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        let objWithSelectAll = [bankDefault, ...data];

        setBankList(objWithSelectAll);
    };

    const VerifyBeni = async (
        values,

        { setSubmitting, resetForm, setFieldValue }
    ) => {
        setResponseMessage('');

        if (values.isAddOnly === true) {
            setIsAddOnly(true);
            core_bene_add(values, values.Name);
            return;
        }
        let jsonObj = {
            Mobile: values.Mobile,
            SenderMobile: values.Mobile,
            Name: values.Name,
            SenderName: SenderName,
            BankName: values.Bank.Name,
            BankID: values.Bank.BankID,
            AccountNo: values.AccountNo,
            IFSC: values.IFSC,
            BeneficiaryID: values.Mobile,
            SenderID: values.Mobile,
            Amount: 1,
            PaymentType: 'IMPS',
            RechargePin: '',
            Through: 'WEB',
            IsVerify: true,
            DMTName: ActiveDMTName,
            OTP: values.OTP,
            OTPRefID: refID,
            PublicIP: values.PublicIP,
            Latitude: values.Latitude,
            Longitude: values.Longitude,
            BankPipe: values.BankPipe
        };

        setIsError(false);
        setLoading(true);

        var apirequest = JSON.stringify(jsonObj);

        var response = await DMT_TRANSFER(apirequest);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);

            setIsError(true);
            return;
        }

        setSeverity('success');
        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        setIsError(true);
        setVerifyStatus(data.Status);

        if (data.Status === 'SUCCESS') {
            setReadOnly(true);
            setFieldValue('IsNameVerified', true);
        }
        createKeyValuePair(data);
        setIsBeneVerifyOpen(true);
        setFieldValue('Name', data.BeneficiaryName);
        setOpenOTP(false);
    };

    const createKeyValuePair = (data) => {
        if (data.Status === 'FAILURE') {
            let rows = [
                VerifyData('Name', data.BeneficiaryName),
                VerifyData('Bank', data.BankName),
                VerifyData('IFSC', data.IFSC),
                VerifyData('Account', data.ConsumerNumber),
                VerifyData('Message', data.Description)
            ];
            setBeneVerifyDetails(rows);
        } else {
            let rows = [
                VerifyData('Name', data.BeneficiaryName),
                VerifyData('Bank', data.BankName),
                VerifyData('IFSC', data.IFSC),
                VerifyData('Account', data.ConsumerNumber)
            ];
            setBeneVerifyDetails(rows);
        }
    };

    function VerifyData(Key, Value) {
        return { Key, Value };
    }
    const core_bene_add = async (values, beneName) => {
        setResponseMessage('');
        var request = {
            Name: beneName,
            BankName: values.Bank.Name,
            BankID: values.Bank.BankID,
            AccountNo: values.AccountNo,
            IFSC: values.IFSC,
            SenderID: values.BeneMobile,
            SenderMobile: values.Mobile,
            DMTName: ActiveDMTName,
            BankPipe: BankPipe
        };

        var requestObj = JSON.stringify(request);
        setLoading(true);
        setIsError(false);

        var response = await BENE_ADD(requestObj);

        if (!response.isAuthorized) LOGOUT();
        setLoading(false);

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        setSeverity('success');
        setIsError(true);

        var param = {
            BeneficiaryID: data.BeneficiaryID,
            Mobile: values.Mobile,
            ActiveDMTName: ActiveDMTName
        };

        if (data.IsOTPRequired === true) {
            history.push('/NTDMT_BeneVerify', param);
            return;
        } else {
            var param = {
                Mobile: values.Mobile,
                DMTName: ActiveDMTName,
                BankPipe: BankPipe
            };

            history.push('/NTDMT_SenderSearch', param);
        }
    };

    const FormValidationSchema = Yup.object({
        Bank: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'bank')
            .required(PLEASE_SELECT_VALID + 'bank')
            .shape({
                Name: Yup.string()
                    .nullable(PLEASE_SELECT_VALID + 'bank')
                    .required(PLEASE_SELECT_VALID + 'bank')
            }),

        Mobile: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'mobile')
            .length(10, PLEASE_PROVIDE_VALID + 'mobile'),
        isAddOnly: Yup.boolean(),

        Name: Yup.string().when(['isAddOnly'], {
            is: (isAddOnly) => isAddOnly,
            then: Yup.string().required(PLEASE_PROVIDE_VALID + 'name')
        }),

        AccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        ConfirmAccountNo: Yup.string().when([], {
            is: () => ShowConfirmAccountNumberInBeneAdd === 'true',
            then: Yup.string()
                .required(PLEASE_PROVIDE_VALID + 'confirm account no')
                .min(7, PLEASE_PROVIDE_VALID + 'account no')
                .max(20, PLEASE_PROVIDE_VALID + 'account no')
                .test('match', "Account numbers don't match", function (value) {
                    return value === this.parent.AccountNo;
                }),
            otherwise: Yup.string().notRequired()
        }),

        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC'),

        BeneMobile: Yup.string().when([], {
            is: () => ShowBeneMobileNumberInBeneAdd === 'true',
            then: Yup.string()
                .required(PLEASE_PROVIDE_VALID + 'bene mobile')
                .length(10, PLEASE_PROVIDE_VALID + 'bene mobile'),
            otherwise: Yup.string().notRequired()
        })
    });
    const submithandle = async (
        values,
        { setSubmitting, resetForm, setFieldValue }
    ) => {
        setResponseMessage('');
        if (values.isAddOnly === true) {
            setIsAddOnly(true);
            core_bene_add(values, values.Name);
            setSubmitting(false);
            return;
        }

        let jsonObj = {
            Mobile: Mobile,
            BeneMobile: values.BeneMobile,
            Name: values.BeniName,
            BeniName: values.BeniName,
            SenderName: values.SenderName,
            BankName: values.Bank.Name,
            AccountNo: values.ConfirmAccountNo,
            IFSC: values.IFSC,
            BeneficiaryID: values.BeneMobile,
            SenderID: Mobile,
            PaymentType: values.PaymentType,
            RechargePin: values.RechargePin,
            Remark: values.Remark,
            DMTName: ActiveDMTName,
            IsVerify: true,
            Pipe: BankPipe,
            BankPipe: BankPipe,
            OriginalAmount: '1',
            //MobileNo: mobile,
            DMTName: ActiveDMTName,
            PublicIP: values.PublicIP,
            Latitude: values.Latitude,
            Longitude: values.Longitude
        };
        setIsError(false);
        setLoading(true);

        var apirequest = JSON.stringify(jsonObj);

        var response = await GENERATE_OTP_ForMoneyTransfer(apirequest);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            setSubmitting(false);
            return;
        }
        var data = JSON.parse(response.data);

        let OTPListRequest = data.list;

        let params = {
            MainRequest: jsonObj,
            OTPListRequest: data.list,
            setFieldValue
        };

        if (OTPListRequest[0]?.Status === 'PROCESS') {
            setOpenOTP(true);
            setVerifyOTPParams(params);
            setOTPRefID(OTPListRequest[0]?.OTPRefid);
        }
        setSubmitting(false);
        return;
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
            >
                {({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <h2
                                        className={classes.PaperHead_h2}
                                        style={{
                                            marginBottom: '16px',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}
                                    >
                                        Beneficiary Add{' '}
                                        <b style={{ marginLeft: '100px' }}>
                                            BankPipe
                                        </b>
                                        : {BankPipe}{' '}
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Field
                                                        component={
                                                            AutoCompleteTextView
                                                        }
                                                        defaultValue={
                                                            bankDefault
                                                        }
                                                        SubFieldName="Name"
                                                        FieldName="Bank"
                                                        name="Bank"
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            setFieldValue(
                                                                'BankID',
                                                                value.BankID
                                                            );

                                                            setFieldValue(
                                                                'IFSC',
                                                                value.DefaultIFSC
                                                            );

                                                            setFieldValue(
                                                                'Bank.Name',
                                                                value.Name
                                                            );

                                                            setBankDefault({
                                                                BankID:
                                                                    value.BankID,
                                                                DefaultIFSC:
                                                                    value.DefaultIFSC,
                                                                Name: value.Name
                                                            });
                                                        }}
                                                        options={bankList}
                                                        getOptionLabel={(
                                                            option
                                                        ) => option.Name}
                                                        getOptionSelected={(
                                                            option,
                                                            value
                                                        ) =>
                                                            option.Name ===
                                                            value.Name
                                                        }
                                                        textFieldProps={{
                                                            label: 'Bank'
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="IFSC"
                                                        name="IFSC"
                                                        type="text"
                                                        length={11}
                                                        placeholder="IFSC"
                                                        readOnly={isReadOnly}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialNumberField
                                                        label="Account No."
                                                        name="AccountNo"
                                                        type={
                                                            ShowConfirmAccountNumberInBeneAdd ===
                                                                'true'
                                                                ? 'password'
                                                                : 'text'
                                                        }
                                                        length={20}
                                                        placeholder="Account No."
                                                        readOnly={isReadOnly}
                                                    />
                                                </Grid>
                                                {ShowConfirmAccountNumberInBeneAdd ===
                                                    'true' && (
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            sm={12}
                                                            md={9}
                                                            lg={9}
                                                        >
                                                            <MaterialNumberField
                                                                label="Confirm Account No."
                                                                name="ConfirmAccountNo"
                                                                type="text"
                                                                length={20}
                                                                placeholder="Confirm Account No."
                                                                readOnly={
                                                                    isReadOnly
                                                                }
                                                            />
                                                        </Grid>
                                                    )}
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <div
                                                        className={
                                                            classes.SubmitWrapper
                                                        }
                                                    >
                                                        <Button
                                                            type="submit"
                                                            title="Verify"
                                                            className={
                                                                classes.CustomPrimaryButtonStyle
                                                            }
                                                            onClick={(e) => {
                                                                setFieldValue(
                                                                    'isAddOnly',
                                                                    false
                                                                );
                                                                handleSubmit(e);
                                                            }}
                                                            disabled={loading}
                                                        >
                                                            Verify
                                                        </Button>
                                                        {loading && (
                                                            <CircularProgress
                                                                size={24}
                                                                className={
                                                                    classes.buttonProgress
                                                                }
                                                            />
                                                        )}
                                                    </div>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Bene Name"
                                                        name="Name"
                                                        type="text"
                                                        placeholder="Bene Name"
                                                        readOnly={isReadOnly}
                                                    />
                                                </Grid>
                                                {ShowBeneMobileNumberInBeneAdd ===
                                                    'true' && (
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            sm={12}
                                                            md={12}
                                                            lg={12}
                                                        >
                                                            <MaterialTextField
                                                                label="Bene Mobile"
                                                                name="BeneMobile"
                                                                type="text"
                                                                length={10}
                                                                placeholder="Bene Mobile"
                                                            />
                                                        </Grid>
                                                    )}
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Mobile"
                                                        name="Mobile"
                                                        type="text"
                                                        length={10}
                                                        readOnly={true}
                                                        placeholder="Mobile"
                                                    />

                                                    <Hidden xsUp>
                                                        <MaterialTextField
                                                            label="SenderID"
                                                            name="SenderID"
                                                            type="text"
                                                            readOnly={true}
                                                            placeholder="SenderID"
                                                        />
                                                    </Hidden>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box
                                            className={classes.flexReverse}
                                            sx={{ gap: '16px' }}
                                        >
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                            >
                                                <Button
                                                    type="submit"
                                                    title="Add"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddOnly',
                                                            true
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                >
                                                    Add
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </Button>
                                            <Button
                                                variant="contained"
                                                style={{
                                                    backgroundColor: '#D5006D',
                                                    color: 'white',
                                                    width: '60px',
                                                    marginLeft: '16px'
                                                }}
                                                onClick={() => {
                                                    history.push(
                                                        '/NTDMT_SenderSearch',
                                                        {
                                                            Mobile: Mobile,
                                                            BankPipe: BankPipe,
                                                            DMTName: ActiveDMTName,
                                                            Name: ''
                                                        }
                                                    );
                                                }}
                                            >
                                                Back
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={8}
                                lg={8}
                                className="lastrecharges"
                            >
                                <h2 className={classes.PaperHead_h2}>
                                    Beneficiary List
                                </h2>
                                <ReactTable data={list} columns={mainColumns} />
                            </Grid>
                        </Grid>
                    );
                }}
            </Formik>

            {isBeneVerifyOpen ? (
                <KeyValueModal
                    isOpen={isBeneVerifyOpen}
                    request={BeneVerifyDetails}
                    title="VERIFY"
                    status={verifyStatus}
                    OKButtonClick={() => {
                        setIsBeneVerifyOpen(false);
                    }}
                />
            ) : null}

            {openOTP ? (
                <OTPModal
                    isOpen={openOTP}
                    title="OTP"
                    request={VerifyOTPParams}
                    error={modalErrorMessage}
                    submitCallback={(otpValues) => {
                        const verificationData = {
                            ...VerifyOTPParams.MainRequest,
                            Bank: {
                                Name: VerifyOTPParams.MainRequest.BankName,
                                IFSC: VerifyOTPParams.MainRequest.IFSC,
                                AccountNo:
                                    VerifyOTPParams.MainRequest.AccountNo,
                                BankID: bankDefault.BankID
                            },
                            BeneficiaryID:
                                VerifyOTPParams.MainRequest.BeneMobile,
                            Name: VerifyOTPParams.MainRequest.SenderName,
                            BeniName: VerifyOTPParams.MainRequest.SenderName,
                            PaymentType: 'IMPS',
                            OTP: otpValues.OTP,
                            IsVerify: true
                        };
                        VerifyBeni(verificationData, {
                            setSubmitting: () => { },
                            resetForm: () => { },
                            setFieldValue: VerifyOTPParams.setFieldValue
                        });
                    }}
                    onDismissCallback={(value) => {
                        setOpenOTP(value);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
